
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'FlowDuration',
})
export default class FlowDuration extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  schema: any;

  @Prop({
    type: Object,
    required: true,
  })
  data: any;

  @Prop({
    type: Array,
    required: true,
  })
  value: any;

  private convertConditions(conds) {
    if (conds == null) {
      return null;
    }
    const ncconds = [];
    for (const c of conds) {
      if (Object.prototype.hasOwnProperty.call(c, 'Active')) {
        const nc = {
          active: c.Active,
          conditions: this.convertConditions(c.Conditions),
          logicalOperator: c.LogicalOperator,
          operator: c.Operator,
          value: c.Value,
          virtualName: c.VirtualName,
        };
        ncconds.push(nc);
      } else {
        ncconds.push(c);
      }
    }
    return ncconds;
  }

  get conditions() {
    const conds = this.value;
    if (conds != null && conds.some((c) => Object.prototype.hasOwnProperty.call(c, 'Active'))) {
      return this.convertConditions(conds);
    }
    return conds;
  }
}
